import script from "./BenefitsVerificationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitsVerificationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitsVerificationDialog.vue?vue&type=style&index=0&id=53508ed6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53508ed6"]])

export default __exports__